import type { RunStatus, ShellSnapshot } from "@ppt-agent/contracts";

export const WORKFLOW_STEPS = ["定意", "谋篇", "成章", "交付"] as const;

const phaseByStatus: Record<RunStatus, number> = {
  CREATED: 1,
  DISCOVERING: 1,
  AWAITING_BRIEF_APPROVAL: 1,
  PLANNING: 2,
  AWAITING_OUTLINE_APPROVAL: 2,
  DESIGNING: 2,
  AWAITING_VISUAL_APPROVAL: 2,
  GENERATING: 3,
  RENDERING: 3,
  EVALUATING: 3,
  REPAIRING: 3,
  EXPORTING: 4,
  COMPLETED: 4,
  PAUSED: 1,
  CANCELLED: 1,
  FAILED: 1,
  NEEDS_ATTENTION: 1,
  SUPERSEDED: 1,
};

const statusLabelByStatus: Record<RunStatus, string> = {
  CREATED: "项目已创建",
  DISCOVERING: "正在整理资料",
  AWAITING_BRIEF_APPROVAL: "等待确认任务书",
  PLANNING: "正在编排故事线",
  AWAITING_OUTLINE_APPROVAL: "等待确认故事线",
  DESIGNING: "正在制定视觉方向",
  AWAITING_VISUAL_APPROVAL: "等待确认视觉方向",
  GENERATING: "正在生成幻灯片",
  RENDERING: "正在渲染预览",
  EVALUATING: "正在检查质量",
  REPAIRING: "正在局部修复",
  EXPORTING: "正在准备交付",
  COMPLETED: "交付文件已准备",
  PAUSED: "任务已暂停",
  CANCELLED: "任务已取消",
  FAILED: "任务失败",
  NEEDS_ATTENTION: "需要你的处理",
  SUPERSEDED: "已有更新版本",
};

export interface ShellViewModel {
  phase: number;
  phaseLabel: string;
  statusLabel: string;
  progressPercent: number;
  stepStates: Array<"completed" | "current" | "pending">;
  approvalCounter: string;
}

export function createShellViewModel(snapshot: ShellSnapshot): ShellViewModel {
  const recordedPhase = snapshot.stageRecords?.findIndex(({ status }) => status === "current");
  const phase = recordedPhase !== undefined && recordedPhase >= 0 ? recordedPhase + 1
    : snapshot.deliveryReady ? 4 : phaseByStatus[snapshot.runStatus];
  const completedApprovals = snapshot.approvals.filter((approval) => approval.status === "completed").length;
  return {
    phase,
    phaseLabel: WORKFLOW_STEPS[phase - 1]!,
    statusLabel: statusLabelByStatus[snapshot.runStatus],
    progressPercent: Math.round((snapshot.progress.completed / snapshot.progress.total) * 100),
    stepStates: WORKFLOW_STEPS.map((_, index) => {
      const step = index + 1;
      if (step < phase) return "completed";
      if (step === phase) return "current";
      return "pending";
    }),
    approvalCounter: snapshot.pendingApproval
      ? "等待确认 " + (completedApprovals + 1) + " / 3"
      : "已确认 " + completedApprovals + " / 3",
  };
}
